"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    // ======================================================
    app: {
      about: 'O aplikácii',
      actions: {
        add: 'Pridať',
        addNamed: 'Pridať {name}',
        remove: 'Zmazať',
        removeNamed: 'Zmazať {name}',
        removeConfirmation: 'Naozaj chcete zmazať?',
        more: 'Viac',
        less: 'Menej',
        download: 'Stiahnuť',
        save: 'Uložiť',
        cancel: 'Zrušiť',
        close: 'Zavrieť',
        moreFormFields: 'Viac polí',
        export: 'Exportovať',
        edit: 'Upraviť',
        createdSuccessMessage: 'Úspešne vytvorené.',
        savedSuccessMessage: 'Úspešne uložené.',
        deletedSuccessMessage: 'Úspešne zmazané',
        detail: 'Detail',
        next: 'Ďálej',
        back: 'Späť',
        start: 'Štart',
        whatNext: 'Čo ďalej...',
        confirm: 'Potvrdenie',
        confirmRemove: 'Naozaj chcete zmazať?',
        search: 'Hľadať',
        userProfile: 'Užívateľský profil',
        tenantProfile: 'Profil vašeho CRM',
        imports: 'Importy',
        fileImports: 'Import súborov',
        settings: 'Nastavenia',
        logout: 'Odhlásenie',
        login: 'Prihlásenie',
        filterList: 'Filtrovať zoznam',
        excel: 'Excel',
        refresh: 'Obnoviť',
        clear: 'Vyčistiť',
        agree: 'Súhlasím',
        disagree: 'Nesúhlasím',
        makeCopy: 'Vytvoriť kópiu',
        fullscreen: 'Na celú obrazovku',
        fullscreenClose: 'Zavrieť mód celej obrazovky',
        copy: 'Kopírovať'
      },
      messages: {
        confirmRemove: 'Naozaj chcete odstrániť túto položku?',
        errorOccurred: 'Nastala chyba',
        createdSuccess: 'Vytvorenie prebehlo úspešne.',
        savedSuccess: 'Uloženie prebehlo úspešne.',
        deletedSuccess: 'Zmazanie prebehlo úspešne.',
        uploadSuccess: 'Súbor uploadovaný úspešne.',
        uploadError: 'Chyba v priebehu uploadovania súboru.',
        uploadInProgress: 'Prebieha upload...',
        uploadedFiles: '{number, plural, one {1 soubor bol uploadnutý} few {{number} súbory boli uploadováné} other {{number} súborov bolo uploadovaných}}'
      },
      error: 'Chyba!',
      validations: {
        isRequired: 'Pole {field} je povinné.',
        minLengthIsRequired: 'Je vyžadovaná aspoň {number, plural, one {1 položka} few {{number} položky} other {{number} položiek}}.',
        minValue: 'Minimálna povolená hodnota je {value}.',
        maxValue: 'Maximálna povolená hodnota je {value}.',
        passwordMatchError: 'Heslá sa nezhodujú',
        invalidEmail: 'Neplatný email.',
        invalidPhoneNumber: 'Neplatné telefónne číslo. Zadajte telefónne číslo v medzinárodnom formáte "+XXX XXX XXX XXX".',
        notValidNumber: 'Neplatné číslo',
        invalidUrl: 'Neplatná URL adresa.',
        positive: 'Číslo musí byť kladné.',
        negative: 'Číslo musí byť záporné.'
      },
      login: {
        title: 'Prihlásenie k Sprinx CRM',
        username: 'Užívateľské meno',
        password: 'Heslo',
        loginButton: 'Prihlásiť',
        error: 'Prihlásenie sa nepodarilo. Užívateľské meno alebo heslo nenájdené',
        pleaseRelogin: 'Zdá se, že nie ste prihlásený. Prosím prihláste sa znovu.'
      },
      days: '{count, plural, one {1 deň} few {{formattedCount} dni} other {{formattedCount} dní}}',
      // values { count, formattedCount}
      overdue: 'oneskorenie {count, plural, one {1 deň} few {{formattedCount} dni} other {{formattedCount} dní}}',
      // values { count, formattedCount}
      newItem: 'Nový',
      anonymizing: {
        confirm: {
          title: 'Potvrďte anonymizáciu',
          content: 'Naozaj chcete anonymizovať osobné údaje?'
        },
        button: 'Anonymizovať osobné údaje'
      },
      appMenu: {
        discover: 'Objavte'
      },
      missingType: 'Prosím v administrácii aplikácie najskôr definujte {typeName}.',
      missingTypeForEntityType: 'Prosím v administrácii aplikácie najskôr definujte {typeName} pre {forEntityTypeName}.',
      emptyScoringBlog: 'Nie sú aktivované moduly, ktorých obsah, alebo nastavenia, sa zobrazujú na tejto stránke.'
    },
    // ======================================================
    components: {
      buttons: {
        showOnMap: 'Ukázať na mape'
      },
      filters: {
        filterButtonSubmit: 'Hľadať',
        filterFieldName: '{name} ({conditionType})',
        addCondition: 'Pridať podmienku',
        resetFilter: 'Resetovať filter',
        operators: {
          contains: {
            _: 'obsahuje',
            0: 'obsahuje'
          },
          containsexact: {
            _: 'obsahuje presne',
            0: 'obsahuje presne'
          },
          notcontains: {
            _: 'neobsahuje',
            0: 'neobsahuje'
          },
          betweennumber: {
            _: 'medzi',
            0: 'od',
            1: 'do'
          },
          betweendate: {
            _: 'medzi',
            0: 'od',
            1: 'do'
          },
          equal: {
            _: 'je rovný',
            0: 'je rovný'
          }
        }
      },
      paginationList: {
        itemsTotal: 'Položiek celkom: {number}',
        nextPage: 'Načítať {number} položiek',
        emptyMessage: 'Položky nenájdené.'
      },
      selects: {
        emptyOption: 'Žiadna',
        emptyMessage: 'Položky nenájdené.'
      },
      tables: {
        labelRowsPerPage: 'Riadkov na stránke',
        sortBy: 'Zoradiť podľa {field}',
        recordsChanged: 'Niektoré záznamy boli pridané alebo zmenené.'
      },
      textField: {
        errorMsgWrapper: 'Chyba: {msg}'
      },
      dateField: {
        invalidDateFormat: 'Nesprávný formát dát.',
        invalidDate: 'Neznámy',
        maxDateMessage: 'Dátum nesmie byť väčší ako maximálny dátum',
        minDateMessage: 'Dátum nesmie byť menší ako minimálny dátum',
        today: 'Dnes'
      },
      detailNavigation: {
        scoringblog: 'Scoring Blog',
        card: 'Karta',
        relations: 'Relácie'
      },
      manipulationInfo: {
        created: 'Vytvorené',
        updated: 'Upravené',
        removed: 'Zmazané'
      }
    }
  }
};
var _default = messages;
exports.default = _default;